export const teamData = [
  {
    name: "Nikhil Tarar",
    role: "Founder and CEO",
    img: "https://i.postimg.cc/fW5zkgVr/456.png",
    desc: "Nikhil Tarar is the Founder of CodeMatrix, a next-generation skill intelligence platform built to identify, measure, and strengthen real-world technical skills. With a strong focus on data-driven insights and practical problem-solving, His goal is to help learners and organizations make smarter decisions through skill analytics, guided improvement, and performance intelligence."
  },
  {
    name: "Ashu Chaudhary",
    role: "Marketing Head",
    img: "https://i.postimg.cc/qMRkKXKF/123.png",
    desc: "Ashu is a Marketing and Communication Manager with 12 years of experience in sales and marketing across multiple organizations, contributing strategic insight and clear communication to support Code Matrix’s growth and positioning"
  }
];